// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__193ce","left":"styles_left__2K8uQ"};